import { CompanyLogo } from '@apps-common/components/common/logos/CompanyLogo'

export const NavbarCompanyLogo = () => <CompanyLogo containerClasses='relative !left-[-10px] !top-[-3px]' />
